import React, { useEffect, useState, useRef } from "react";
import "../App/App.scss";
import "../../css/bootstrap.css";
import "../KnovoMainScreen/KnovoMainScreen.css";
import "../KnovoClassesScreen/KnovoClassesScreen.css";
import { connect } from "react-redux";
import UserActions from "../../store/user/Actions";
import "../HomeScreen/HomeScreen.css";
import LessonPodItemSkeleton from "../CommonItems/LessonPodItemSkeleton";
import LessonPodItem from "../CommonItems/LessonPodItem";
import ActivityList from "../CommonItems/ActivityList";
import { Tab, Tabs, TabList } from "carbon-components-react";
import { Column, Grid } from "carbon-components-react";
import EmptyScreen from "../CommonItems/EmptyScreen";
import Images from "../../images";
import { GET_LESSON_UNITS, GET_UPCOMIN_ASSIGN_LIST } from "../../constants";
function KnovoLessonScreen(props) {
  const { user, lessonUnitDetails, token } = props; // get local data
  const { getUpcomingAssignmentForStudent, getLessonUnitDetailsForStudent } =
    props; //Api's
  const {
    saveUnitName,
    saveFromPending,
    showOrHideToaster,
    refreshToken,
    userToken,
  } = props; //store local
  const [internalLoading, setInternalLoading] = useState(false);
  const [internalLoadingPopup, setInternalLoadingPopup] = useState(false);
  const [currentAssignmentsData, setCurrentAssignmentsData] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [displayActivityModal, setDisplayActivityModal] = useState(false);
  // const [selectedAssaignmentData, setSelectedAssaignmentData] = useState({});
  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const selectedAssaignmentData = useRef({});

  useEffect(() => {
    setInternalLoading(true);
    //get today lessons list
    if (selectedTabIndex === 0) {
      var assDate = todayDate();
      getLessonPodList(assDate, token);
    } else {
      //get all lessons list
      getLessonPodList("All", token);
    }
  }, [selectedTabIndex]);

  function todayDate() {
    var date = new Date(),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var assDate = [date.getFullYear(), mnth, day].join("-");
    return assDate;
  }

  function getLessonPodList(dateValue, tokenData) {
    getUpcomingAssignmentForStudent(
      user.LoginID,
      dateValue,
      tokenData,
      (responseLessonPods) => {
        if (responseLessonPods.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setCurrentAssignmentsData(responseLessonPods.Data);
          }, 2000);
        } else if (responseLessonPods.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_UPCOMIN_ASSIGN_LIST);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, responseLessonPods.StatusMessage, "error");
        }
      }
    );
  }

  function getLessonUnitDetails(lessonUnitDistId, lessonUnitName, tokenData) {
    saveUnitName(lessonUnitName);
    saveFromPending(true);
    setInternalLoadingPopup(true);
    setDisplayActivityModal(true);
    getLessonUnitDetailsForStudent(
      user.LoginID,
      lessonUnitDistId,
      tokenData,
      (activitiesList) => {
        if (activitiesList.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setInternalLoadingPopup(false);
          }, 2000);
        } else if (activitiesList.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_LESSON_UNITS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setInternalLoadingPopup(false);
          }
        } else {
          setInternalLoading(false);
          setInternalLoadingPopup(false);
          showOrHideToaster(true, activitiesList.StatusMessage, "error");
        }
      }
    );
  }

  function refreshTokenCall(apiType) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiType === GET_UPCOMIN_ASSIGN_LIST) {
          if (selectedTabIndex === 0) {
            var assDate = todayDate();
            getLessonPodList(assDate, tokenResponse.Token);
          } else {
            //get all lessons list
            getLessonPodList("All", tokenResponse.Token);
          }
        } else if (apiType === GET_LESSON_UNITS) {
          getLessonUnitDetails(
            selectedAssaignmentData.current.LessonUnitDistID,
            selectedAssaignmentData.current.LessonName,
            tokenResponse.Token
          );
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
        setInternalLoading(false);
      }
    });
  }

  function getFormattedDateChange(dateValue) {
    var dateFormat = "";
    if (dateValue && dateValue !== "") {
      var date = new Date(dateValue);
      var weekday = new Array(7);
      weekday[0] = "Sun";
      weekday[1] = "Mon";
      weekday[2] = "Tue";
      weekday[3] = "Wed";
      weekday[4] = "Thu";
      weekday[5] = "Fri";
      weekday[6] = "Sat";
      var dayText = weekday[date.getDay()];
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : "0" + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : "0" + day;
      var dat = dateValue.toString().split(":");
      var dat1 = dat[0];
      var dat2 = dat[1];
      var dat3 = dat[2].split(" ");
      var dat4 = dat3[1];
      dateFormat = dayText + " " + dat1 + ":" + dat2 + " " + dat4;
    } else {
      dateFormat = "";
    }
    return dateFormat;
  }

  const lessonItemColorOdd = ["#4922fd", "#3ec986"];
  const lessonItemColorEven = ["#00b2ff", "#FFC42D"];

  function getRandomItem(arr) {
    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);

    // get random item
    const item = arr[randomIndex];

    return item;
  }

  function renderLessonsData() {
    return (
      <Grid className="home-grid-style">
        {currentAssignmentsData &&
          currentAssignmentsData.map((assignment, index) => {
            return (
              <Column
                className="home-column-style"
                lg={4}
                md={4}
                sm={4}
                onClick={() => {
                  selectedAssaignmentData.current = assignment;
                  // setSelectedAssaignmentData(assignment);
                  getLessonUnitDetails(
                    assignment.LessonUnitDistID,
                    assignment.LessonName,
                    token
                  );
                }}
              >
                <LessonPodItem
                  CourseName=""
                  LessonName={assignment.LessonName}
                  DueDate={getFormattedDateChange(
                    assignment.TargetCompletionDateTime
                  )}
                  LessonColor={
                    index % 2
                      ? getRandomItem(lessonItemColorEven)
                      : getRandomItem(lessonItemColorOdd)
                  }
                />
              </Column>
            );
          })}
      </Grid>
    );
  }

  return (
    <div className="knovo-classes-container">
      <div className="classes-navigation-item"> </div>
      <div className="classes-canvas-container">
        <div className="assignment-navigation-container">
          <div className="assignment-navigation">
            <Tabs
              selectedIndex={selectedTabIndex}
              defaultChecked={selectedTabIndex}
            >
              <TabList aria-label="List of lesson tabs">
                <Tab
                  onClick={() => {
                    setSelectedTabIndex(0);
                  }}
                >
                  Today
                </Tab>
                <Tab
                  onClick={() => {
                    setSelectedTabIndex(1);
                  }}
                >
                  All
                </Tab>
              </TabList>
            </Tabs>
          </div>
        </div>
        {internalLoading ? (
          <div className="data-container">
            <Grid className="home-grid-style" condensed>
              {Array.from(Array(8)).map((assignment, index) => {
                return (
                  <Column className="home-column-style" lg={4} md={4} sm={4}>
                    <LessonPodItemSkeleton />
                  </Column>
                );
              })}
            </Grid>
          </div>
        ) : (
          <div className="data-container">
            {currentAssignmentsData.length > 0 ? (
              renderLessonsData()
            ) : (
              <EmptyScreen
                imageAnime={Images.empty_anim_3}
                emptyMessage={"You don't have any lessons to complete today"}
              />
            )}
          </div>
        )}
      </div>
      {displayActivityModal && (
        <ActivityList
          activityListData={
            lessonUnitDetails.Data && lessonUnitDetails.Data.length > 0
              ? lessonUnitDetails.Data
              : []
          }
          selectedCourseName={
            selectedAssaignmentData.current.CourseName
              ? selectedAssaignmentData.current.CourseName
              : ""
          }
          selectedLessonName={
            selectedAssaignmentData.current.LessonName
              ? selectedAssaignmentData.current.LessonName
              : ""
          }
          selectedTargetDate={
            selectedAssaignmentData.current.TargetCompletionDateTime
              ? getFormattedDateChange(
                  selectedAssaignmentData.current.TargetCompletionDateTime
                )
              : ""
          }
          selectedAssignmentData={selectedAssaignmentData.current}
          onCloseClick={() => {
            setDisplayActivityModal(false);
          }}
          internalLoading={internalLoadingPopup}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  courseList: state.user.courseList,
  loading: state.user.loading,
  lessonUnitDetails: state.user.lessonUnitDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getUpcomingAssignmentForStudent: (
    studentId,
    assignmentDate,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getUpcomingAssignmentForStudent(
        studentId,
        assignmentDate,
        token,
        successFn
      )
    ),
  getLessonUnitDetailsForStudent: (
    studentId,
    lessonUnitDistId,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getLessonUnitDetailsForStudent(
        studentId,
        lessonUnitDistId,
        token,
        successFn
      )
    ),
  saveUnitName: (unitName) => dispatch(UserActions.saveUnitName(unitName)),
  saveFromPending: (fromPending) =>
    dispatch(UserActions.saveFromPending(fromPending)),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(KnovoLessonScreen);
